// Mapeo de nombres de evoluciones para cada clase
export const classEvolutions: Record<string, Record<number, string>> = {
  'Dark Wizard': {
    1: 'Dark Wizard',
    2: 'Soul Master',
    3: 'Grand Master',
    4: 'Sould Wizard',
    5: 'Darkness Wizard'
  },
  'Dark Knight': {
    1: 'Dark Knight',
    2: 'Blade Knight',
    3: 'Blade Master',
    4: 'Dragon Knight',
    5: 'Ignition Knight'
  },
  'Fairy Elf': {
    1: 'Fairy Elf',
    2: 'Muse Elf',
    3: 'High Elf',
    4: 'Nombre Elf',
    5: 'Royal Elf'
  },
  'Magic Gladiator': {
    1: 'Magic Gladiator',
    2: 'Duel Master',
    3: 'Magic Knight',
    4: 'Duple Knight'
  },
  'Dark Lord': {
    1: 'Dark Lord',
    2: 'Lord Emperor',
    3: 'Empire Lord',
    4: 'Force Empire'
  },
  'Summoner': {
    1: 'Summoner',
    2: 'Boody Summoner',
    3: 'Dimension Master',
    4: 'Dimension Summoner'
  },
  'Rage Fighter': {
    1: 'Rage Fighter',
    2: 'Fist Master',
    3: 'Fist Blazer',
    4: 'Bloody Fighter'
  },
  'Grow Lancer': {
    1: 'Grow Lancer',
    2: 'Mirage Lancer',
    3: 'Shinning Lancer',
    4: 'Arcane Lancer'
  },
  'Rune Wizard': {
    1: 'Rune Wizard',
    2: 'Rune Speel Master',
    3: 'Grand Rune Master',
    4: 'Majestic Rune Wizard',
    5: 'Infinity Rune Wizard'
  },
  'Slayer': {
    1: 'Slayer',
    2: 'Royal Slayer',
    3: 'Master Slayer',
    4: 'Slaughterer',
    5: 'Rogue Slayer'
  },
  'Gun Crusher': {
    1: 'Gun Crusher',
    2: 'Gun Breaker',
    3: 'Master Gun Breaker',
    4: 'Heist Gun Crusher',
    5: 'Magnus Gun Crusher'
  },
  'White Wizard': {
    1: 'White Wizard',
    2: 'Light Master',
    3: 'Shine Wizard',
    4: 'Luminous Wizard',
    5: 'Glory Wizard'
  },
  'Lemuria Mage': {
    1: 'Lemuria',
    2: 'WO Mage',
    3: 'Arch Mage',
    4: 'Mystic Mage',
    5: 'Battle Mage'
  },
  'Illusion Knight': {
    1: 'Illusion Knight',
    2: 'Mirage Knight',
    3: 'Illusion Master',
    4: 'Mystic Knight',
    5: 'Phantom Pain Knight'
  },
  'Alchemist': {
    1: 'Alchemist',
    2: 'Alchemic Magician',
    3: 'Alchemic Master',
    4: 'Alchemic Force',
    5: 'Creator'
  }
};

// Función de utilidad para obtener el nombre de la evolución
export const getEvolutionName = (className: string, evoLevel: string | number): string => {
  // Convertir evoLevel a número si es string
  const evo = typeof evoLevel === 'string' ? parseInt(evoLevel, 10) : evoLevel;
  
  // Intentar encontrar la clase exacta
  if (classEvolutions[className] && classEvolutions[className][evo]) {
    return classEvolutions[className][evo];
  }
  
  // Si no se encuentra, devolver un formato genérico
  return `${className} (Evo ${evo})`;
};
